import React from 'react';
import {StyledDescription} from "../Description/styled";
import { Typography} from  "antd";
import {Container} from "@mui/material";
const { Title } = Typography;
const { Paragraph, Text } = Typography;
const ShortAbout = () => {
    return (
        <Container  maxWidth="xl">
            <p>
                <Title style={{color: "white", textAlign: "center"}} italic color={"white"} level={3}>Кто мы?</Title>
            </p>

            <StyledDescription>

                <Paragraph ellipsis={false} style={{color: "white"} }>Вообще изначально, мы задумывали шить отличные сноубордические худи, но пока мы перешивали наши лекала, наступила весна и понимание того, что к такому мы не готовы. Уж слишком сложно сделать что-то хорошее да еще и по доступной цене😅 Минул год…  и теперь мы делаем баффы и хобы (пока)! Делаем качественно и стараемся не задирать цену. Изо всех сил стараемся, но тяжелее с каждым днем.  Кстати…GoBananas - это два человека: Анна и Евгений. Анна у нас отвечает за красоту всего и вся(за принты и идеи) и она же всё это потом шьет и отпаривает)))
                    Евгений - это собственно Я😱))) Я пишу буду писать для вас посты в телеге, уже давно отвечаю на ваши отзывы на маркетплейсах и помогаю изо всех сил (таскаю рулоны, крою, делаю хобы кстати😎) Вот такие дела))</Paragraph>
            </StyledDescription>
            <Title style={{color: "white", textAlign: "center"}} italic color={"white"} level={3}>Что мы можем?</Title>
            <StyledDescription>
                <Paragraph ellipsis={false} style={{color: "white"} }>
                    Пока только баффы и туристические сидушки. Мы рисуем, генерируем и всячески добываем принты на наши изделия. Их очень много. Если вам ничего не подошло и вы хотите что-то свое или с логотипом вашего сообщества, компании или фотографией - мы это с легкостью можем сделать. Любой бафф или хобу нежного размера и с нужным принтом! Просто напишите нам и мы договоримся))
                </Paragraph>
            </StyledDescription>
            {/*<ProductSlider/>*/}
        </Container>
    );
};

export default ShortAbout;